
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 17.931C14.908 16.121 17.545 15 20.457 15 26.279 15 31 19.478 31 25M20 14c3.314 0 6-2.684 6-6a6 6 0 0 0-6-6 6 6 0 0 0-6 6c0 3.316 2.686 6 6 6zM8.583 16.328a1.998 1.998 0 0 0 0-2.823l-2.117-2.12a2.001 2.001 0 0 0-2.827 0l-1.162 1.163a2.988 2.988 0 0 0-.377 3.77 46.34 46.34 0 0 0 12.985 12.985 2.997 2.997 0 0 0 3.77-.379l1.16-1.16c.376-.376.585-.883.585-1.413s-.209-1.04-.584-1.413l-2.119-2.119a1.998 1.998 0 0 0-2.825 0l-.706.705a47.464 47.464 0 0 1-6.493-6.493l.71-.703z","stroke":"currentColor","stroke-width":"2","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    